import { Box, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../../../theme";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../../Dashboard/Header";
import Button from "@mui/material/Button";
import VerifiedIcon from "@mui/icons-material/Verified";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Grid,
} from "@mui/material";
import Swal from "sweetalert2";
import CancelIcon from "@mui/icons-material/Cancel";
const PREFERENCE_KEY = "infiniteAppUserPreferences";

export default function StkItemFinalApproval() {
  const [PriStkItm, setStockItem] = useState([]);
  const token = localStorage.getItem("token");
  const cmpid = localStorage.getItem("cmpid");
  const [selectedIds, setSelectedIds] = useState([]);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [pageSize, setPageSize] = useState(20);

  // Load saved user preferences from localStorage
  const saved = localStorage.getItem(PREFERENCE_KEY);
  const preferences = saved
    ? JSON.parse(saved)
    : {
        rowHeight: 40,
        fontFamily: "Source Sans Pro",
        fontSize: 16,
        tableAlign: "center",
      };

  //call after Component load
  useEffect(() => {
    fetchData();
  }, [token, cmpid]);

  //fuction to fetch Primary Approval voucher list
  const fetchData = async () => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + "/approvalModule/stkPrimaryList",
        { cmpid },
        {
          headers: { Authorization: token },
        }
      );
      const arrayData = Object.values(response.data);
      setStockItem(arrayData);
      // console.log(arrayData);
    } catch (error) {
      console.log(error);
    }
  };

  //approval function for single stock item
  const handleApproval = (id) => {
    try {
      axios.post(
        process.env.REACT_APP_API_URL + `/approvalModule/stkPrimaryUpdate`,
        { stkid: id },
        {
          headers: { Authorization: token },
        }
      );
      // Success Alert
      Swal.fire({
        title: "Approved!",
        text: "stock Item Approved successfully.",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#28a745",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },

        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
      fetchData();
    } catch (error) {
      console.log(error);
    }
  };

  //function for bulk approval
  const handleApprovalAll = () => {
    const selectedstkIIds = rows
      .filter((row) => selectedIds.includes(row.id))
      .map((row) => row.id);

    const formattedArray = selectedstkIIds.map((id) => ({
      stkid: id,
    }));
    if (formattedArray.length === 0) {
      Swal.fire({
        title: "Warning",
        text: "Please select check box for Multiple Approval.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#f0ad4e",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },
      });
      return;
    }

    try {
      axios.post(
        process.env.REACT_APP_API_URL + "/approvalModule/allStkPrimaryUpdate",
        formattedArray,
        {
          headers: { Authorization: token },
        }
      );
      Swal.fire({
        title: "Approved!",
        text: "Approved successfully.",
        icon: "success",
        confirmButtonText: "OK",
        confirmButtonColor: "#28a745",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },

        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
      fetchData();
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
        confirmButtonText: "Close",
        confirmButtonColor: "red",
        width: "300px",
        padding: "1em",
        customClass: {
          popup: "small-alert",
        },
      });
    }
  };

  //rows for vouchers table
  const rows = Array.isArray(PriStkItm)
    ? PriStkItm.map((Pristk) => ({
        id: Pristk.stkItem_Id,
        stkItem_Name: Pristk.stkItem_Name,
        stkItem_Parent: Pristk.stkItem_Parent,
        stkItem_Category: Pristk.stkItem_Category,
        stkItem_PartNo: Pristk.stkItem_PartNo,
        stkItem_Unit: Pristk.stkItem_Unit,
      }))
    : [];

  //colums width for Final Stock Item table

  const getColumnWidth = (rows, field, header) => {
    const maxLength = Math.max(
      ...rows.map((r) => (r[field] ? r[field].toString().length : 0)),
      header.length
    );
    return maxLength * 10 + 15;
  };

  const columns = [
    {
      field: "stkItem_Name",
      headerName: "Name",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "stkItem_Name", "Name"),
    },
    {
      field: "stkItem_PartNo",
      headerName: "Part No",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "stkItem_PartNo", "Part No"),
    },
    {
      field: "stkItem_Parent",
      headerName: "Parent",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "stkItem_Parent", "Parent"),
    },
    {
      field: "stkItem_Category",
      headerName: "Category",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "stkItem_Category", "Category"),
    },

    {
      field: "stkItem_Unit",
      headerName: "Unit",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      width: getColumnWidth(rows, "stkItem_Unit", "Unit"),
    },

    {
      field: "Action",
      headerName: "",
      headerAlign: preferences.tableAlign,
      align: preferences.tableAlign,
      headerClassName: "sticky-col-header",
      cellClassName: "sticky-col",
      width: 150,
      renderCell: (PriItem) => (
        <Box>
          <Button
            variant="contained"
            color="success"
            startIcon={<VerifiedIcon />}
            type="button"
            style={{ height: 20, fontSize: 15 }}
            onClick={(e) => {
              e.stopPropagation();
              handleApproval(PriItem.id);
            }}
          >
            Approve
          </Button>
        </Box>
      ),
    },
  ];

  //===========================
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const [StkIData, setStkIData] = useState([]);

  const handleShowData = async (stkid) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + `/display/stockItemDetails`,
        { stkid },
        {
          headers: { Authorization: token },
        }
      );
      const StkIData = response.data.rows[0];
      setStkIData(StkIData);
      // console.log(StkIData);
    } catch (error) {
      console.error("Error updating voucher status:", error);
    }
    setOpen(true);
  };

  return (
    <>
      <Dialog open={open}>
        <DialogTitle
          variant="h2"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Stock Item Details
          <CancelIcon
            sx={{
              cursor: "pointer",
              fontSize: "32px",
              height: "30px",
              width: "30px",
              marginRight: "0px",
              marginTop: "0px",
            }}
            onClick={handleClose}
          />
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={2} mb={2}>
            <Grid item xs={6}>
              <TextField
                label="Name"
                value={StkIData.stkItem_Name}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Unit"
                value={StkIData.stkItem_Unit}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Closing Qty"
                value={StkIData.stkItem_ClosingQty}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Closing Rate"
                value={StkIData.stkItem_ClosingRate}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            {/* <Grid item xs={6}>
              <TextField
                label="Country"
                //  value={LedData.led_Country}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="State"
                //  value={LedData.led_State}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="Pincode"
                //  value={LedData.led_Pincode}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="PAN/IT No"
                //  value={LedData.led_Pan}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="GST Reg Type"
                // value={LedData.led_GSTReg}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="GSTIN No"
                //  value={LedData.led_GSTIN}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid> */}
          </Grid>
        </DialogContent>
      </Dialog>

      {/* // button for selected Approval */}

      <Box mt="70px" ml="0px" mr="20px">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Header
            title="Stock Item Approval"
            subtitle="Final Stock Item Approval"
          />
          <Button
            variant="contained"
            color="success"
            sx={{
              height: "30px",
              minHeight: "30px",
            }}
            onClick={handleApprovalAll}
          >
            Approve All
          </Button>
        </Box>

        {/* vouchers table  */}
        <Box
          height="80vh"
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: `1px solid ${colors.grey[700]} !important`,
              cursor: "pointer",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "none",
              color: colors.primary[150],
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[700],
              color: colors.primary[150],
            },
            "& .MuiDataGrid-cell:focus": { outline: "none" },
            // ✅ Add horizontal grid lines
            "& .MuiDataGrid-row": {
              borderBottom: `1px solid ${colors.grey[700]} !important`,
            },
            // ✅ Zoom on hover using a class
            "& .Stkzoom-row:hover": {
              transform: "scale(1.01)",
              transition: "transform 0.2s ease-in-out",
              zIndex: 1,
              backgroundColor: colors.blueAccent[900],
            },
            // ✅ Sticky column styles
            "& .sticky-col-header": {
              position: "sticky",
              right: 0,
              zIndex: 2,
              backgroundColor: colors.blueAccent[700],
            },
            "& .sticky-col": {
              position: "sticky",
              right: 0,
              zIndex: 1,
              backgroundColor: colors.primary[400],
            },
            "& .Stkzoom-row:hover .sticky-col": {
              backgroundColor: colors.blueAccent[900],
            },
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={pageSize}
            onRowClick={(params) => handleShowData(params.row.id)}
            getRowClassName={() => "Stkzoom-row"}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            rowHeight={30}
            headerHeight={30}
            componentsProps={{
              footer: {
                sx: {
                  height: 30,
                  minHeight: 30,
                },
              },
            }}
            checkboxSelection
            onSelectionModelChange={(newSelection) =>
              setSelectedIds(newSelection)
            }
            sx={{
              "& .MuiDataGrid-virtualScroller": {
                overflow: "auto",
              },
            }}
          />
        </Box>
      </Box>
    </>
  );
}